module.exports = __webpack_public_path__ + "img/stahnout_fakturu.c09cce49.svg";